// extracted by mini-css-extract-plugin
export default {"error":"Input_error__tDULF","errorText":"Input_errorText__NiP+e"};